var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dialog_right" }, [
    _c(
      "div",
      { staticClass: "pres_line" },
      [_c("presLine", { attrs: { presData: _vm.dialog_data } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "video" }, [
      _c(
        "div",
        { staticClass: "video_box" },
        [
          _vm.srcList.length > 0
            ? _c("el-image", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: { src: _vm.url, "preview-src-list": _vm.srcList }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c6c6428", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c6c6428","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialog_right.vue
// module id = null
// module chunks = 